import React from "react";

export const MenuItemText = ({ primaryText, secondaryText }) => (
  <div>
    <p className="primaryText">{primaryText}</p>
    <p className="secondaryText">{secondaryText}</p>
  </div>
);
